/**
 * Manage image path requests using the
 * DatasourceManager's url templating system.
 *
 * @example :
            resourcePath.get('mugshot',{ pid : '12345'})
 *            =>  "http://mlb.mlb.com/images/gameday/mugshots/mlb/12345.jpg"

 *          resourcePath.get('mugshot')
 *            =>  "http://mlb.mlb.com/images/gameday/mugshots/mlb/default.jpg"
 *
 * @note : To customize url's for differnt projects (milb?), just override paths with set.
 *
 * @example :
 *          resourcePath.set('mugshot',"http://gdx.mlb.com/images/gameday/mugshots/milb/{pid}.jpg")
 *          resourcePath.set({
 *              'mugshot' : ""http://gdx.mlb.com/images/gameday/mugshots/milb/{pid}.jpg"
 *          })
 **/
 
define('gameday-resource-path/gameday-resource-path',['require','exports','module','resource-path-manager/resource-path-manager'],function(require,exports,module){
    var ResourcePathManager = require( "resource-path-manager/resource-path-manager" ),
        gamedayResourcePath = new ResourcePathManager();
    
    gamedayResourcePath.set({
            // Images
        mugshot : "http://gdx.mlb.com/images/gameday/mugshots/mlb/{pid:default}@2x.jpg",
        mugshotMlb : "http://gdx.mlb.com/images/gameday/mugshots/mlb/{pid:default}.jpg",
        mugshotMilb : "http://www.milb.com/images/{pid}/{tid:generic}/124x150/{pid}.jpg",
        mugshotMilbGeneric : "http://www.milb.com/images/{pid}/generic/124x150/{pid}.jpg",
        mugshotDefault : "http://ui.bamstatic.com/clubs/mlb/images/player-default@2x.png",
        mugshotMilbDefault : "http://ui.bamstatic.com/clubs/mlb/images/player-default@2x.png",
        playerHeader  : "http://mlb.mlb.com/images/players/525x330/{pid}.jpg",
        playerAltHeader  : "http://mlb.mlb.com/images/players/525x330/alt/{pid}.jpg",
        playerHeaderDefault : "http://wapc.mlb.com/images/apps/summary_photo_default.png",
        batter : "http://wapc.mlb.com/images/apps/batters_{cut}/2016/{team}-{homeOrAway}-{stand}@2x.png",
        nonRetinaBatter : "http://wapc.mlb.com/images/apps/batters_{cut}/{team}-{homeOrAway}-{stand}.png",
        field : "http://mlb.mlb.com/images/gameday/fields/svg/{id:generic}.svg",
        fieldPNG : "http://wapc.mlb.com/images/apps/fields_ipad/{id:generic}@2x.png",
        stadiumTop : "http://ui.bamstatic.com/fedapp/gameday/gdapp/mlb/v1.0.0/assets/img/stadiums/{phase}/{id:default}{density}.jpg",
        stadiumBottom : "http://ui.bamstatic.com/fedapp/gameday/gdapp/mlb/v1.0.0/assets/img/stadiums/field/GamedayBackdropBottom{density}.jpg",
        teamLogoLarge : "http://mlb.mlb.com/mlb/images/team_logos/124x150/{file_code}@2x.png",
        teamLogoLargeGeneric : "http://mlb.mlb.com/mlb/images/team_logos/124x150/mlb@2x.png",
        teamLogoCircular : "http://mlb.mlb.com/mlb/images/team_logos/circular/{file_code}@2x.png",

            //Other
        ticketLink      : "http://mlb.mlb.com/ticketing/singlegame.jsp?c_id={file_code}#game={game_pk}",
        highlightsLink  : "http://m.mlb.com/video?game_pk={game_pk}",
        playVideoLink   : "http://mlb.mlb.com/video/play.jsp?content_id={cid}&game_pk={game_pk}",
        recapLink       : "http://m.mlb.com/news/article/{cid}?game_pk={game_pk}",
        shareVideoLink           : "http://mlb.mlb.com/v{cid}",
        externalPlayerCardLink  : {
            env_qa : "http://mqa.mlb.com/player/{pid}",
            env_beta : "http://mbeta.mlb.com/player/{pid}",
            env_prod : "http://m.mlb.com/player/{pid}"
        },
        internalPlayerCardLink  : {
            env_qa : "http://mqa.mlb.com/gameday/player/{pid}",
            env_beta : "http://mbeta.mlb.com/gameday/player/{pid}",
            env_prod : "http://m.mlb.com/gameday/player/{pid}"
        }
    });

    return gamedayResourcePath;
});

